export const DASHBOARD_FILE_KEY_PROPERTY_NAME = 'key';

export const COPY_AND_UPGRADE = 'copy_and_upgrade';
